// extracted by mini-css-extract-plugin
export default {"productDescription":"d_-z","featuredDescription":"e_-z","description":"f_-z","more":"g_-z","descriptionSku":"h_-z"};